import React, { useMemo } from 'react'
import { CustomDropdown } from '../../../../../components'
import { getTps } from '../../../../../services/localstorage/localstorage.service'

export default function SelectOperadorLogistico({
  value,
  onChange,
  disabled = false,
  label = 'Operador Logístico:*',
}) {
  const tps = useMemo(() => getTps(false), [])
  const selecionado = tps.find(tp => tp.id === value) || null

  return (
    <CustomDropdown
      optionLabel="name"
      options={tps}
      value={selecionado}
      label={label}
      filter={tps.length > 5}
      disabled={disabled}
      onChange={onChange}
    />
  )
}
